<template>
<div class="z-main">
	<header class="z-header">
		<div><router-link to="/index"><img src="../assets/left.png" /></router-link></div>
		<div>{{$route.query.title}}</div>
		<div>&nbsp;</div>
	</header>
	<div class="z-body z-body-bottom0" style=" overflow-y: scroll;-webkit-overflow-scrolling:touch;">
		<iframe :src="src" frameborder="0" name="crmIframe" style="width: 100%;height: 100%;"></iframe>
	</div>
</div>
</template>

<script>
export default {
	name: 'crm',
	data() {
		return {
			src:'',
			timestamp:Date.parse(new Date())
		}
	},
	created() {
		this.src = 'static/crm/'+this.$route.query.href+'.html';
	},
	methods: {
	},
	destroyed:function () {
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>



// WEBPACK FOOTER //
// src/pages/crm.vue